import React from 'react'
import { HeaderUI, type HeaderUIProps } from '@/components/Header/HeaderUI'

export type HeaderBlockProps = HeaderUIProps & {
  blockType: 'headerBlock'
}

export const HeaderBlock: React.FC<HeaderBlockProps> = (props) => {
  return <HeaderUI {...props} />
}

export default HeaderBlock